<template>
  <div>
    <Header/>
    <ProjectOverviewBody>
      <ProjectOverview
        title="Digrab"
        image="digrab/Digrab_Logo.png"
        description="In Digrab you play as a Space Soldier who has crashed on an asteroid. Your ship is under dozens of rocks and your ennemies are still shooting at you. Dig for your ship while protecting yourself from the incomming missiles !"
        :tags="['C#', 'Unity', '2D']"
        timeline="August - September 2018"
        team="1 Game Designer & 1 Game Art"

        :keypoints="[
            'First 2D game on Unity',
            'Made all the code',
            'Art and Sound integration'
        ]"

        :categories="[
            '2D',
            'C#',
            'Unity'
        ]"
      />
      <ProjectOverviewVideo source="digrab/Digrab_Showreel.webm" thumbnail="digrab/Digrab_Showreel_Thumbnail.jpg"/>
      <ProjectOverviewCarrousel :images="[
          'digrab/Digrab_Carrousel_1.png',
          'digrab/Digrab_Carrousel_2.png',
          'digrab/Digrab_Carrousel_3.png'
      ]"/>
    </ProjectOverviewBody>
  </div>
</template>

<script>

import ProjectOverviewBody from "@/components/ProjectOverviewBody";
import ProjectOverview from "@/components/ProjectOverview";
import ProjectOverviewVideo from "@/components/ProjectOverviewVideo";
import ProjectOverviewCarrousel from "@/components/ProjectOverviewCarrousel";
import Header from "@/components/Header";

export default {
name: "Digrab",
  components:{
    Header,
    ProjectOverviewBody,
    ProjectOverview,
    ProjectOverviewVideo,
    ProjectOverviewCarrousel
  }
}
</script>

<style scoped>

</style>